module.exports = __webpack_public_path__ + "img/hr_logo_icon.35a920bf.png";